import { fetchPictogram, fetchPictogramLayers, getPictogramDesign as apiGetPictogramDesign } from "../api/pictograms.api";

/**
 * Obtiene un pictograma
 * @param {number} pictogramId - El ID del pictograma
 * @param {object} filters - Filtros para la consulta
 * @returns {Promise<object>} - El pictograma
 */
export async function getPictogram(pictogramId) {
  try {
    const filters = {
      only_pictogram: 1,
    }
    const pictogram = await fetchPictogram(pictogramId, filters);
    return pictogram;
  } catch (e) {
    console.error("Error al obtener el pictograma: ", e);
    throw e;
  }
}

export async function getPictogramLayers(pictogramId, params = {}) {
  try {
    const response = await fetchPictogramLayers(pictogramId, params);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 422) {
      error.error_msg = error.response.data.errors[
        Object.keys(error.response.data.errors)[0]
      ][0];
    }
    throw error;
  }
}

export async function getPictogramDesign(pictogramId) {
  try {
    const response = await apiGetPictogramDesign(pictogramId);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 422) {
      error.error_msg = error.response.data.errors[
        Object.keys(error.response.data.errors)[0]
      ][0];
    }
    throw error;
  }
}
